var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.7383C14.7448 13.7383 15.375 14.0104 15.8906 14.5547C16.4062 15.0703 16.6641 15.6862 16.6641 16.4023C16.6641 17.1471 16.3919 17.7917 15.8477 18.3359C15.332 18.8516 14.7161 19.1094 14 19.1094C13.2839 19.1094 12.6536 18.8516 12.1094 18.3359C11.5938 17.7917 11.3359 17.1471 11.3359 16.4023C11.3359 16.1159 11.3503 15.9154 11.3789 15.8008L4.89062 12.0195C4.34635 12.5065 3.71615 12.75 3 12.75C2.25521 12.75 1.61068 12.4779 1.06641 11.9336C0.522135 11.3893 0.25 10.7448 0.25 10C0.25 9.25521 0.522135 8.61068 1.06641 8.06641C1.61068 7.52214 2.25521 7.25 3 7.25C3.71615 7.25 4.34635 7.49349 4.89062 7.98047L11.3359 4.24219C11.2786 3.95573 11.25 3.74089 11.25 3.59766C11.25 2.85286 11.5221 2.20833 12.0664 1.66406C12.6107 1.11979 13.2552 0.847656 14 0.847656C14.7448 0.847656 15.3893 1.11979 15.9336 1.66406C16.4779 2.20833 16.75 2.85286 16.75 3.59766C16.75 4.34245 16.4779 4.98698 15.9336 5.53125C15.3893 6.07552 14.7448 6.34766 14 6.34766C13.3125 6.34766 12.6823 6.08984 12.1094 5.57422L5.66406 9.35547C5.72135 9.64193 5.75 9.85677 5.75 10C5.75 10.1432 5.72135 10.3581 5.66406 10.6445L12.1953 14.4258C12.7109 13.9674 13.3125 13.7383 14 13.7383Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.bd916aef5d19f08178be38ac401f59b0.svg";
export { ForwardRef as ReactComponent };